import { RequestAction } from '.';

export const upload = (type, files) => {
  const data = new FormData();
  [...files].forEach(file => data.append('files[]', file));
  return RequestAction.request(type, {
    data,
    method: 'post',
    url: `/api/upload`,
  });
};
